import { NavLink, Outlet, Navigate, useNavigate } from 'react-router'
import { useAdminAuth } from '../context/AdminAuthContext'

const NAV = [
  {
    section: 'Principal',
    items: [
      { to: '/', label: 'Dashboard', icon: '▦', exact: true },
      { to: '/alertas', label: 'Alertas', icon: '🔔', badge: null, badgeKey: 'alertas' },
    ],
  },
  {
    section: 'Tenants',
    items: [
      { to: '/empresas',  label: 'Empresas',      icon: '🏢' },
      { to: '/wizard',    label: 'Nuevo cliente', icon: '✦'  },
      { to: '/db-health', label: 'Salud de BDs',  icon: '🗄' },
    ],
  },
  {
    section: 'Files',
    items: [
      { to: '/backup', label: 'Backup', icon: '🗜' },
    ],
  },
  {
    section: 'Reportes',
    items: [
      { to: '/reportes', label: 'Reportes MH', icon: '📊' },
    ],
  },
  {
    section: 'Sistema',
    items: [
      { to: '/logs',          label: 'Logs del sistema', icon: '🖥' },
      { to: '/whatsapp-logs', label: 'Logs WhatsApp',    icon: '💬' },
      { to: '/catalogos', label: 'Catálogos', icon: '📚' },
    ],
  },
]

export default function AdminLayout() {
  const { admin, isAuthenticated, loading, logout } = useAdminAuth()
  const navigate = useNavigate()

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'var(--muted)' }}>
      Cargando…
    </div>
  )

  if (!isAuthenticated) return <Navigate to="/login" replace />

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  const initials = admin?.name
    ? admin.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()
    : 'SA'

  return (
    <div className="app-shell">
      {/* ── Sidebar ── */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <div className="logo-icon">e</div>
          <span className="logo-text">e<span>Factura</span> BO</span>
        </div>

        <nav className="sidebar-nav">
          {NAV.map(group => (
            <div key={group.section}>
              <div className="nav-section">{group.section}</div>
              {group.items.map(item => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.exact}
                  className={({ isActive }) => `nav-item${isActive ? ' active' : ''}`}
                >
                  <span className="nav-icon">{item.icon}</span>
                  {item.label}
                </NavLink>
              ))}
            </div>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="avatar">{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="avatar-name" style={{ overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
              {admin?.name ?? 'Admin'}
            </div>
            <div className="avatar-role">{admin?.role ?? 'super_admin'}</div>
          </div>
          <button
            onClick={handleLogout}
            style={{ background:'none', border:'none', color:'var(--muted)', cursor:'pointer', fontSize:'14px' }}
            title="Cerrar sesión"
          >
            ⎋
          </button>
        </div>
      </aside>

      {/* ── Main ── */}
      <main className="main">
        <Outlet />
      </main>
    </div>
  )
}
